import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Camera, Sparkle, Tag, X } from "@phosphor-icons/react";

const STEPS = [
  {
    icon: Camera,
    title: "1. Fotografa",
    text: "Tocca \"Identifica\" e scatta la foto del fronte del reperto. Retro e lati sono opzionali ma aiutano l'AI.",
  },
  {
    icon: Sparkle,
    title: "2. L'AI cataloga per te",
    text: "In meno di un minuto ricevi nome, descrizione, aneddoto storico, valore stimato e un codice unico (es. M1). Funziona subito, senza configurazioni.",
  },
  {
    icon: Tag,
    title: "3. Etichetta e organizza",
    text: "Riporta il codice sulla bustina fisica per ritrovare l'oggetto al volo. Poi esplora statistiche, mappa e condividi il catalogo con un link ospite.",
  },
];

// One-time 3-step onboarding shown on the Home page at first access
// (empty catalog + per-user localStorage flag).
export const WelcomeGuide = () => {
  const { user } = useAuth();
  const flagKey = user ? `reperti-welcome-seen-${user.id}` : null;
  const [open, setOpen] = useState(() => flagKey && !localStorage.getItem(flagKey));

  if (!open) return null;
  const dismiss = () => {
    localStorage.setItem(flagKey, "1");
    setOpen(false);
  };

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm flex items-center justify-center px-4 py-6 overflow-y-auto"
      onClick={dismiss}
      data-testid="welcome-guide-modal"
    >
      <div
        className="card max-w-lg w-full p-7 md:p-9 relative fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={dismiss}
          className="absolute top-3 right-3 text-[#5C635A] hover:text-[#1E2520]"
          aria-label="Chiudi"
          data-testid="welcome-guide-close"
        >
          <X size={20} />
        </button>

        <div className="label-eyebrow mb-2">Benvenuto{user?.name ? `, ${user.name}` : ""}</div>
        <h2 className="font-serif text-3xl text-[#1E2520] mb-6">
          Cataloga il primo reperto in 3 passi
        </h2>

        <div className="space-y-5 mb-8">
          {STEPS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="flex items-start gap-4">
              <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center bg-[#9C5B42] text-white">
                <Icon weight="duotone" size={22} />
              </span>
              <div>
                <div className="font-serif text-xl text-[#1E2520] leading-tight mb-1">{title}</div>
                <p className="text-sm text-[#5C635A] leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/scan"
            onClick={dismiss}
            className="btn-primary inline-flex items-center justify-center gap-2 flex-1"
            data-testid="welcome-guide-start"
          >
            <Camera weight="duotone" size={18} /> Identifica il primo reperto
          </Link>
          <button
            onClick={dismiss}
            className="btn-ghost flex-1"
            data-testid="welcome-guide-skip"
          >
            Esploro prima l'app
          </button>
        </div>
      </div>
    </div>
  );
};
